import * as React from "react"
import { cn } from "@/utilities/ui"

interface UnderlineInputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

export const UnderlineInput = React.forwardRef<HTMLInputElement, UnderlineInputProps>(
  ({ className, ...props }, ref) => {
    return (
      <input
        ref={ref}
        className={cn(
          "block w-full border-0 border-b border-gray-300 bg-transparent px-0 py-2 text-gray-900 placeholder:text-gray-400 focus:border-b-1 focus:border-[#8D8D8D] focus:outline-none focus:ring-0 sm:text-sm",
          className
        )}
        {...props}
      />
    )
  }
)

UnderlineInput.displayName = "UnderlineInput"
